import { render } from "./TheRechargesV2Dashboard.vue?vue&type=template&id=96be5284"
const script = {}

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__